import React, { FC } from "react";
import { useMapEvents } from "react-leaflet";

type Props = {
  setPosition: (pos: [number, number]) => void;
};

export const LocationMarker: FC<Props> = ({ setPosition }) => {
  useMapEvents({
    click(e) {
      setPosition([e.latlng.lat, e.latlng.lng]);
    },
  });

  return null;
};
